import React from 'react';
import pluralize from 'pluralize';
import { Button, Typography } from 'seagull';
import { DropdownMenu } from 'seagull/components/DropdownMenu';
import { AgreementsLiner18, MailSentLiner24, TrashLine, WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import { Intent } from "../../infra/access-control";
import styles from "./DraftsDashboard.module.scss";
const BulkActions = _ref => {
  let {
    numSelected,
    setBulkActionsOpen,
    bulkActionsOpen,
    bulkSend,
    bulkExternallySign,
    bulkDiscard
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, numSelected > 0 && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "drafts-dashboard-bulk-counter"
  }, "".concat(numSelected, " ").concat(pluralize('draft', numSelected), " selected")), /*#__PURE__*/React.createElement(DropdownMenu, {
    onOpenChange: setBulkActionsOpen,
    target: /*#__PURE__*/React.createElement(Button, {
      "data-testid": "drafts-dashboard-bulk-actions",
      skin: "primaryOutline",
      suffixIcon: bulkActionsOpen ? /*#__PURE__*/React.createElement(WideArrowUpward, null) : /*#__PURE__*/React.createElement(WideArrowDownward, null),
      highlight: bulkActionsOpen,
      disabled: numSelected === 0
    }, "Bulk actions")
  }, [{
    icon: /*#__PURE__*/React.createElement(MailSentLiner24, {
      size: 20
    }),
    testid: 'drafts-dashboard-bulk-send',
    text: 'Send proposals',
    onClick: bulkSend
  }, {
    icon: /*#__PURE__*/React.createElement(AgreementsLiner18, {
      size: 20
    }),
    testid: 'drafts-dashboard-bulk-externally-sign',
    text: 'Approve on behalf of the client',
    onClick: bulkExternallySign
  }, {
    icon: /*#__PURE__*/React.createElement(TrashLine, null),
    testid: 'drafts-dashboard-bulk-remove',
    text: 'Discard drafts',
    intent: Intent.DiscardDraft,
    skin: 'error',
    onClick: bulkDiscard
  }].map(_ref2 => {
    let {
      icon,
      testid,
      text,
      intent,
      skin,
      onClick
    } = _ref2;
    return /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      key: testid,
      iconStart: /*#__PURE__*/React.createElement("div", {
        className: styles.bulkActionIcon
      }, icon),
      "data-testid": testid,
      intent: intent,
      skin: skin,
      onClick: onClick
    }, text);
  })));
};
export default BulkActions;